const btn = 'bg-bloom-olive hover:bg-[#9aa161] font-bloom-sans font-light text-stone-50 rounded-lg px-8 py-2 drop-shadow-md'

module.exports = btn